<template>
  <footer
    class="form-fw__footer"
    :class="{ 'form-fw__footer--shadow': shadow }"
  >
    <div class="form-fw__footer__container py-2">
      <div class="text-xs-right">
        <v-btn
          type="button"
          color="accent"
          depressed
          round
          @click="$router.push({ name: 'Financial' })"
        >
          {{ $t(`${namespace}.labelButton`) }}
        </v-btn>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data () {
    return {
      namespace: 'Views.InvoiceExtendDueDateSoldOutRequests.footer',
      shadow: true
    }
  },
  methods: {
    handleShadow () {
      this.shadow = !((window.innerHeight + window.scrollY) >= document.body.offsetHeight)
    }
  },
  mounted () {
    this.handleShadow()
    window.addEventListener('scroll', this.handleShadow)
  },
  beforeDestroy () {
    window.removeEventListener('scroll', this.handleShadow)
  }
}
</script>
